import React from 'react';
import { useForm } from 'react-hook-form';
import { SwitchField } from 'components/form';
import { Box, Button, Stack, Tooltip } from '@mui/material';
import { TasksPortalConfiguration } from '../types';
import { Help } from '@mui/icons-material';

interface Props {
  isLoading: boolean;
  defaultValues: TasksPortalConfiguration;
  onConfirm: (configuration: TasksPortalConfiguration) => Promise<void>;
}

export const TasksManagementForm = ({ isLoading, defaultValues, onConfirm }: Props) => {
  const { control, handleSubmit } = useForm<TasksPortalConfiguration>({
    defaultValues,
  });

  return (
    <Box sx={{ display: 'grid', gridTemplateRows: '1fr auto', gap: '1rem', height: '100%' }}>
      <Stack gap="0.5rem">
        <Stack direction="row" alignItems="center" justifyContent="space-between" gap="0.5rem">
          <SwitchField
            label="Automate Credit References on Receipt of Credit Application"
            control={control}
            name="isAutoTaskEnabledForTradeRef"
          />

          <Tooltip title="Requires reference email to be received on application">
            <Help color="info" />
          </Tooltip>
        </Stack>
      </Stack>

      <Box>
        <Button loading={isLoading} variant="contained" onClick={handleSubmit(onConfirm)}>
          Save
        </Button>
      </Box>
    </Box>
  );
};
